import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {
    FirstName: '',
    LastName: '',
    FullNameCompany: '',
    NID: '',
    Email: '',
    Mobile: '',
    Pwd: '',
    ConfirmPwd: ''
  },
  errors: {},
  tokenError: '',
  isEdit: false,
  successMessage: '',
  isSuccessUpdate: false,
  ifError: false,
  error: '',
  userError: {},
  currentInputClass: ""
};

const personalDataSlice = createSlice({
  name: 'personalData',
  initialState,
  reducers: {
    resetStatus: (state) => {
      state.isSuccessUpdate = false;
      state.successMessage = "";
      state.errors = {};
      state.ifError = false;
      state.error = "";
      state.userError = {};
      state.errorMessage = "";
      state.tokenError = "";
    },
    setAllPersonalData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    setPersonalField: (state, action) => {
      const { field, value } = action.payload;
      state.data[field] = value;
    },
    setPersonalErrors: (state, action) => {
      state.errors = action.payload;
    },
    setTokenError: (state, action) => {
      state.tokenError = action.payload;
    },
    setSuccessMessage: (state, action) => {
      state.successMessage = action.payload;
    },
    setIsSuccessUpdate: (state, action) => {
      state.isSuccessUpdate = action.payload;
    },
    setIsEdit: (state, action) => {
     state.isEdit = action.payload;
    },
    setPersonalUserErrors: (state, action) => {
      state.userErrors = action.payload;
    },
    setIfError: (state, action) => {
     state.ifError = action.payload;
    },
    setErrorMessage: (state, action) => {
     state.errorMessage = action.payload;
    },
    setCurrentInputClass: (state, action) => {
     state.currentInputClass = action.payload;
    },
  }
});

export const {
  setPersonalField,
  setPersonalErrors,
  setTokenError,
  setSuccessMessage,
  setIsSuccessUpdate,
  resetStatus,
  setCurrentInputClass,
  setErrorMessage,
  setIfError,
  setPersonalUserErrors,
  setIsEdit,
  setAllPersonalData,
  setSuccessUpdate
} = personalDataSlice.actions;

export default personalDataSlice.reducer;

// selectors
export const selectPersonalData = (state) => state.personalData;
